
import { configureStore } from '@reduxjs/toolkit'
import loginReducer  from '../slice/AuthSlice'
import CompanyReducer  from '../slice/CountryListSlice'
import MembershipReducer from '../slice/MembershipSlice'
import  DataReducer  from '../slice/DataSlice'
import Newsreducer from '../slice/NewsSlice'
import Eventreducer from '../slice/Eventslice'
import FreightReducer from '../slice/FreightRequestSlice'
import ProfileReducer  from '../slice/ProfileSlice'
import TimelineReducer from '../slice/TimelineSlice'
import BusinessReducer from '../slice/NMMBuisnessSlice'
import GalleryReducer  from '../slice/GallerySlice'
import DirectoryReducer from '../slice/DirectorySlice';
import  CertificateReducer from '../slice/CertificateSlice'
import MemberReducer from '../slice/MemberSlice';
import DashboardReducer  from '../slice/DashboardSlice'
import InvoiceReducer from "../slice/InvoiceSlice"
import Chatreducer from '../slice/ChatSlice'

 

export const store = configureStore({
  reducer: {
    AuthSlice:loginReducer,
    countrySlice:CompanyReducer,
    MembershipSlice:MembershipReducer,
    DataSlice:DataReducer,
    NewsSlice:Newsreducer,
    EventSlice:Eventreducer,
    FreightRequest:FreightReducer,
    ProfileSlice:ProfileReducer ,
    TimelineSlice:TimelineReducer,
    NmmBuisness:BusinessReducer,
    GallerySlice:GalleryReducer,
    DirectorySlice:DirectoryReducer,
    CertificateSlice:CertificateReducer,
    MemberSlice:MemberReducer,
    DashboardSlice:DashboardReducer,
    InvoiceSlice:InvoiceReducer,
    ChatSlice:Chatreducer
  },
})
